import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

function setSlider(slider) {
  const paginationEl = slider.closest('.js-hero')?.querySelector('.swiper-pagination');
  const delay = slider.dataset.sliderDelay ? parseInt(slider.dataset.sliderDelay, 10) : 5000;
  const speed = slider.dataset.sliderSpeed ? parseInt(slider.dataset.sliderSpeed, 10) : 2500;
  const effect = slider.dataset.sliderEffect === 'true';

  // eslint-disable-next-line no-new
  new Swiper(slider, {
    loop: true,
    effect: 'fade',
    speed,
    watchSlidesProgress: true,
    autoplay: {
      delay,
      disableOnInteraction: false,
    },
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: true,
    pagination: {
      el: paginationEl,
      clickable: true,
      renderBullet: (index, className) => `<span class="${className}" data-index="${index}">
                <span class="number">${index + 1}</span>
                <span class="progress-inner"></span>
            </span>`,
    },
    on: {
      init() {
        paginationEl?.querySelectorAll('.progress-inner').forEach((bar) => {
          bar.style.width = '0%';
        });

        if (effect) {
          this.slides[this.activeIndex].classList.add('is-zooming');
        }
      },
      slideChangeTransitionStart() {
        if (effect) {
          this.slides[this.activeIndex].classList.add('is-zooming');
        }
      },
      slideChangeTransitionEnd() {
        if (effect) {
          this.slides.forEach((slide, index) => {
            if (index !== this.activeIndex) {
              slide.classList.remove('is-zooming');
            }
          });
        }
      },
      autoplayTimeLeft(swiper, time, progress) {
        const currentBullet = paginationEl?.querySelectorAll('.progress-inner')[swiper.realIndex];

        if (currentBullet) {
          currentBullet.style.width = `${(1 - progress) * 100}%`;
        }
      },
      slideChange() {
        paginationEl?.querySelectorAll('.progress-inner').forEach((bar) => {
          bar.style.width = '0%';
        });
      },
    },
  });
}

document.querySelectorAll('.js-hero-swiper').forEach(setSlider);
